import { getCodingCodeKey } from "../config/storageKeys";
import { storageGetJson, storageSetJson } from "./storage";

const readTopicCodeCache = (topicId) => {
  if (!topicId) return {};
  const key = getCodingCodeKey(topicId);
  const parsed = storageGetJson(key, {});
  return parsed && typeof parsed === "object" ? parsed : {};
};

export const readCachedCode = (topicId, language) => {
  if (!topicId || !language) return null;
  const cache = readTopicCodeCache(topicId);
  const cached = cache?.[language];
  return typeof cached === "string" ? cached : null;
};

export const writeCachedCode = (topicId, language, code) => {
  if (!topicId || !language) return;
  const key = getCodingCodeKey(topicId);
  const cache = readTopicCodeCache(topicId);
  const next = { ...cache, [language]: code };
  storageSetJson(key, next);
};
